import { render } from "./contratosView.vue?vue&type=template&id=6927509f"
import script from "./contratosView.vue?vue&type=script&lang=js"
export * from "./contratosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__